export const cleanupSubjectString = (subject: string) => {
    return subject
        .replaceAll('<img class="ProseMirror-separator" alt="">', '')
        .replaceAll('<br class="ProseMirror-trailingBreak">', '');
};
